import React from 'react';
import Select from '../Select/Select';
import { CAR_DOCUMENT_TYPES } from '../../constants';

const SelectCarDocumentType = ({ ...props }) => {
  return <Select options={CAR_DOCUMENT_TYPES} label={'Тип документа'} placeholder={'Выберите из списка'} {...props} />;
};

export default SelectCarDocumentType;
